import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

import ClassBannerService from '../../ClassBannerService'

import {
  BOOK_STUDENT_CLASS_BANNER,
  CHANGE_BOOKING_STATUS,
  RESET_BOOK_STUDENT_CLASS_BANNER_ERROR,
  RESET_CHANGE_BOOKING_STATUS_ERROR,
  SUBMIT_CLASS_REVIEW,
} from './classBannerBooking.actionTypes'

import { defaultErrorMessage } from '../../../constants'

export const bookStudentClassBanner = createAsyncThunk(BOOK_STUDENT_CLASS_BANNER, async (data) => {
  try {
    const response = await ClassBannerService.bookStudentClassBanner(data)

    if (response.data?.error) {
      if (typeof response.data.error === 'object') {
        const errorMessage = Object.values(response.data.error)
          .map((error) => error.toString())
          .join(', ')
        throw new Error(errorMessage)
      }

      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const changeBookingStatus = createAsyncThunk(CHANGE_BOOKING_STATUS, async (data) => {
  try {
    const response = await ClassBannerService.changeBookingStatus(data.id, data.data)

    if (response.data?.error) {
      if (typeof response.data.error === 'object') {
        const errorMessage = Object.values(response.data.error)
          .map((error) => error.toString())
          .join(', ')
        throw new Error(errorMessage)
      }

      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const submitClassReview = createAsyncThunk(SUBMIT_CLASS_REVIEW, async (data) => {
  try {
    const response = await ClassBannerService.submitClassReview(data.id, data.data)

    if (response.data?.error) {
      if (typeof response.data.error === 'object') {
        const errorMessage = Object.values(response.data.error)
          .map((error) => error.toString())
          .join(', ')
        throw new Error(errorMessage)
      }

      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const resetClassBannerBookingError = createAction(RESET_BOOK_STUDENT_CLASS_BANNER_ERROR)
export const resetChangeBookingStatusError = createAction(RESET_CHANGE_BOOKING_STATUS_ERROR)
